import { jsxs as s, jsx as x } from "react/jsx-runtime";
import { cleanUrl as L, isOrHandleAsExternalUrl as j } from "../../../helpers/link-helper.js";
import "dayjs";
import w from "./link-wrapper.module.less.js";
import { getLinkComponent as y } from "../../../registry/link-registry.js";
const W = ({ onClick: n, title: r, className: t, children: p }) => /* @__PURE__ */ x("span", { role: "button", onClick: n, className: t, children: p || r }), E = ({
  title: n,
  url: r,
  className: t,
  target: p,
  ariaLabel: i,
  rel: f,
  children: o,
  currentPageUrl: e,
  onClickCurrentPageLink: m,
  onPreNavigate: u,
  enableExternalLinkIcon: b
}) => {
  let k = !1;
  const c = y(), C = (a) => {
    k || typeof u != "function" || (a.persist(), a.preventDefault(), u(a), k = !0, a.currentTarget.click());
  };
  if (!r)
    return /* @__PURE__ */ s("span", { className: t, children: [
      o && o,
      !o && n
    ] });
  if (r = L(r), e && e === r)
    return /* @__PURE__ */ s(
      W,
      {
        className: t,
        onClick: m || void 0,
        title: n,
        children: [
          o && o,
          !o && n
        ]
      }
    );
  if (j(r, p))
    return /* @__PURE__ */ s(
      "a",
      {
        onClick: C,
        "aria-label": i,
        href: r,
        target: p,
        className: `${t} mb-0`,
        rel: f,
        children: [
          o && o,
          !o && n,
          b && /* @__PURE__ */ x("span", { className: `${w.iconRight} ui-icon-arrow-outward` })
        ]
      }
    );
  if (c)
    return /* @__PURE__ */ s(c, { onClick: C, "aria-label": i, className: t, url: r, rel: f, children: [
      o && o,
      !o && n
    ] });
};
export {
  E as default
};
